import Vue from 'vue'

import httpManager from '../../util/common'
import LimitMask from '../../common/components/mask.vue'



let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      panes:[],
      showMask: false
    }
  },
  methods: {
    getData() {
      let self = this
      httpManager("release_notes", null)
        .then(response => {
          self.panes = response.data.data
        })
        .catch(error => {
          if (this.$route.path === '/home' && error.response.status === 403) {
            this.showMask = true
          }
          console.log(error)
          self.loading = false
        })
    },

  },
  mounted() {
    this.getData()
  },

  watch: {}
}
Vue.component("release-notes-board", vm)
export default vm



// WEBPACK FOOTER //
// ./src/home/js/release_notes_board.js